const snowIcon = (
  <svg
    width="61"
    height="40"
    viewBox="0 0 61 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_201)">
      <path
        d="M24.1212 35.1484C24.0482 34.9967 23.9648 34.8449 23.8865 34.7021V34.2067C23.9648 34.0594 24.0325 33.9165 24.1055 33.7603C24.1785 33.6041 24.1472 33.4524 23.923 33.3809L23.4016 33.2069L23.0105 32.8811C22.9323 32.707 22.8646 32.5508 22.7863 32.3946C22.7728 32.3636 22.7519 32.3355 22.7249 32.3119C22.6979 32.2883 22.6654 32.2698 22.6295 32.2576C22.5937 32.2454 22.5552 32.2398 22.5167 32.2411C22.4781 32.2424 22.4403 32.2506 22.4057 32.2651C22.3066 32.2964 22.2128 32.3365 22.1137 32.3722L21.8582 32.4704H21.3159C21.1647 32.4124 21.0239 32.3678 20.8936 32.3098C20.5859 32.1803 20.4347 32.2428 20.3304 32.5061C20.2831 32.6322 20.2274 32.7559 20.1636 32.8766L19.7725 33.2113L19.2511 33.3943C19.2108 33.404 19.1735 33.4213 19.1421 33.445C19.1108 33.4688 19.0861 33.4983 19.07 33.5314C19.054 33.5645 19.0469 33.6003 19.0494 33.6361C19.0518 33.6719 19.0637 33.7067 19.0842 33.738C19.1468 33.8674 19.2198 33.9969 19.2824 34.1263L19.3137 34.1933V34.6664L19.0738 35.1395C19.0562 35.1693 19.0464 35.202 19.0451 35.2354C19.0439 35.2687 19.0512 35.3019 19.0667 35.3326C19.0821 35.3632 19.1052 35.3906 19.1344 35.4128C19.1635 35.435 19.1981 35.4514 19.2355 35.4608L19.5327 35.5635L19.8038 35.6528L20.1792 35.9786C20.247 36.1303 20.3148 36.2732 20.3774 36.4249C20.3864 36.4664 20.4076 36.5052 20.4389 36.5378C20.4702 36.5704 20.5107 36.5957 20.5565 36.6113C20.6023 36.6269 20.652 36.6323 20.7009 36.627C20.7498 36.6217 20.7964 36.606 20.8362 36.5811L21.3576 36.3981H21.8791L22.1606 36.5008L22.4213 36.5945C22.4579 36.6121 22.4986 36.6223 22.5404 36.6244C22.5822 36.6265 22.624 36.6204 22.6627 36.6067C22.7013 36.5929 22.7359 36.5718 22.7636 36.545C22.7913 36.5181 22.8116 36.4862 22.8228 36.4517C22.8854 36.3178 22.948 36.1839 23.0053 36.05C23.0053 36.05 23.0053 36.0188 23.0418 35.983L23.4225 35.6572L23.8761 35.501L23.9856 35.4653C24.019 35.4523 24.0491 35.4338 24.0741 35.4108C24.099 35.3877 24.1184 35.3607 24.131 35.3312C24.1436 35.3017 24.1493 35.2703 24.1476 35.239C24.1459 35.2076 24.1369 35.1768 24.1212 35.1484V35.1484Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.5766 29.2747V39.7768"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.5766 29.0739V39.7768"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M20.4139 29.6541L21.5714 30.2298L22.7551 29.605"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.7551 39.2769L21.5975 38.6967L20.4139 39.326"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.1602 30.645L25.9983 38.2147"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.8109 31.7607L18.1092 31.4662L18.4273 30.3102"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.4154 37.1479L25.1223 37.4381L24.8042 38.5985"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M26.0661 30.6404L17.2228 38.2102"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.7625 30.3414L25.1014 31.4528L26.4571 31.725"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.469 38.5628L18.1248 37.4559L16.7744 37.1837"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.9119 34.4521H15.4082"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M27.234 33.4523L26.5614 34.4432L27.2914 35.4564"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9922 35.4564L16.6701 34.4655L15.9401 33.4523"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.1816 32.2026L36.0044 31.8589V31.5063L36.166 31.1939C36.2338 31.0511 36.166 30.9663 36.0304 30.9127L35.655 30.7967L35.3682 30.5556C35.3109 30.4307 35.2587 30.3146 35.2014 30.1986C35.1924 30.1755 35.1778 30.1544 35.1584 30.1366C35.1391 30.1189 35.1155 30.1048 35.0893 30.0955C35.0631 30.0862 35.0349 30.0818 35.0066 30.0827C34.9782 30.0835 34.9504 30.0896 34.925 30.1004L34.706 30.1807L34.5235 30.2521H34.1168C34.0073 30.212 33.903 30.1807 33.8039 30.1361C33.5797 30.0379 33.4702 30.087 33.3972 30.2834C33.3607 30.3726 33.3138 30.4574 33.2721 30.5512L32.9853 30.8011L32.589 30.935C32.5596 30.942 32.5324 30.9545 32.5094 30.9717C32.4865 30.9889 32.4683 31.0102 32.4563 31.0342C32.4442 31.0582 32.4387 31.0843 32.44 31.1103C32.4413 31.1364 32.4495 31.1619 32.4639 31.185C32.516 31.2787 32.563 31.3769 32.6151 31.4706V31.5197V31.8678C32.5578 31.9884 32.4952 32.0999 32.443 32.216C32.4304 32.2377 32.4233 32.2615 32.4224 32.2858C32.4214 32.3101 32.4265 32.3342 32.4374 32.3566C32.4483 32.3791 32.4646 32.3992 32.4854 32.4158C32.5062 32.4323 32.5308 32.4449 32.5578 32.4525L32.7767 32.5284L32.9801 32.5954L33.2512 32.8319C33.3034 32.9435 33.3555 33.0462 33.4025 33.1533C33.4494 33.2604 33.5693 33.3318 33.7362 33.2693L34.1012 33.1354H34.5027L34.706 33.2113L34.8989 33.2827C34.926 33.2959 34.9563 33.3036 34.9874 33.3052C35.0185 33.3067 35.0496 33.3022 35.0784 33.2918C35.1071 33.2815 35.1327 33.2656 35.1531 33.2454C35.1735 33.2253 35.1882 33.2014 35.1961 33.1756C35.2379 33.0774 35.2848 32.9792 35.3265 32.8855C35.3265 32.8855 35.3265 32.8587 35.3526 32.8319L35.6341 32.5954L35.9679 32.4793L36.0461 32.4525C36.0764 32.4467 36.1047 32.4349 36.1289 32.4182C36.1531 32.4015 36.1725 32.3802 36.1856 32.3561C36.1987 32.3319 36.2051 32.3055 36.2044 32.2789C36.2038 32.2523 36.196 32.2262 36.1816 32.2026V32.2026Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.3098 27.8821V35.6036"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M34.3098 27.7349V35.6036"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M33.4546 28.1589L34.3045 28.5873L35.1753 28.1276"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M35.1753 35.2332L34.3254 34.8092L33.4546 35.2689"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.0613 28.8909L37.5634 34.4521"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.8058 29.7076L31.76 29.4934L31.9946 28.6454"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.8658 33.671L36.9168 33.8853L36.6822 34.7377"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.6051 28.8864L31.1082 34.4477"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M36.6509 28.6677L36.9012 29.4845L37.8971 29.6854"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M32.0259 34.711L31.7756 33.8942L30.7797 33.6934"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.966 31.6849H29.7734"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.4707 30.9529L37.9701 31.6804L38.5072 32.4258"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30.2061 32.4258L30.7015 31.6982L30.1644 30.9529"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M46.3077 29.2078L46.1825 28.9623V28.7034C46.2243 28.6231 46.2608 28.5472 46.3025 28.4713C46.3442 28.3954 46.3025 28.3106 46.2034 28.2705L45.927 28.1767L45.7185 27.9982C45.6768 27.9089 45.6403 27.8241 45.5986 27.7438C45.5918 27.7269 45.581 27.7115 45.5667 27.6985C45.5524 27.6856 45.5351 27.6753 45.5158 27.6686C45.4966 27.6618 45.4758 27.6587 45.455 27.6593C45.4342 27.66 45.4138 27.6644 45.3952 27.6724L45.2388 27.7304L45.1032 27.7795H44.806L44.5818 27.6947C44.4149 27.6233 44.3367 27.659 44.2794 27.8018C44.2543 27.8687 44.2247 27.9343 44.1907 27.9982L43.9821 28.1812L43.6901 28.2794C43.6693 28.2845 43.65 28.2936 43.6338 28.3059C43.6175 28.3182 43.6047 28.3335 43.5962 28.3506C43.5877 28.3677 43.5838 28.3862 43.5847 28.4048C43.5856 28.4233 43.5914 28.4415 43.6015 28.4579L43.711 28.6722C43.7126 28.684 43.7126 28.696 43.711 28.7079V28.9578C43.6693 29.0471 43.6276 29.1274 43.5859 29.2122C43.5766 29.2282 43.5714 29.2456 43.5706 29.2634C43.5698 29.2812 43.5735 29.299 43.5814 29.3155C43.5893 29.3319 43.6012 29.3468 43.6164 29.359C43.6316 29.3712 43.6496 29.3805 43.6693 29.3863L43.8309 29.4398L43.9769 29.4889L44.1751 29.663C44.2168 29.7434 44.2481 29.8192 44.2846 29.8951C44.3211 29.971 44.4045 30.029 44.5296 29.9799L44.7956 29.8817H45.0876L45.2388 29.9353L45.3796 29.9888C45.3993 29.9983 45.4213 30.0038 45.444 30.0048C45.4666 30.0057 45.4891 30.0022 45.5099 29.9944C45.5306 29.9866 45.549 29.9748 45.5634 29.9599C45.5779 29.945 45.5882 29.9274 45.5933 29.9085C45.6246 29.8371 45.6559 29.7657 45.6924 29.6943C45.6911 29.6824 45.6911 29.6704 45.6924 29.6585L45.8958 29.4845L46.1408 29.3997H46.2034C46.2279 29.397 46.2512 29.3891 46.2712 29.3766C46.2912 29.3642 46.3071 29.3476 46.3175 29.3284C46.3279 29.3092 46.3325 29.2881 46.3308 29.267C46.3291 29.2459 46.3211 29.2255 46.3077 29.2078V29.2078Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.9415 26.0566V31.6893"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.9415 25.9495V31.6893"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.321 26.262L44.9363 26.57L45.5725 26.2352"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M45.5725 31.4216L44.952 31.1091L44.321 31.4483"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.5743 26.7931L47.314 30.8502"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M42.3866 27.3912L43.0801 27.235L43.2522 26.6146"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.5382 30.2789L46.8447 30.4351L46.6727 31.0555"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.3505 26.7886L42.6056 30.8502"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M46.6518 26.6324L46.8343 27.2261L47.5591 27.3734"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M43.273 31.0377L43.0905 30.4441L42.3657 30.2968"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.3412 28.8328H41.6357"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.9762 28.2972L47.6165 28.8284L48.0075 29.3729"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.9486 29.3729L42.3084 28.8418L41.9173 28.2972"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M40.3895 22.1067C40.4913 22.0002 40.6333 21.9276 40.791 21.9013C42.8698 21.7048 44.8625 21.0816 46.5997 20.0848C49.9576 22.2049 52.8307 22.495 55.6985 21.0355C58.1909 19.7634 59.7134 17.2417 59.2233 14.8538C58.5037 11.2832 55.8236 9.49786 51.6992 9.24346C50.3226 4.83373 47.1784 1.90135 41.9434 1.09795C35.8167 0.160663 31.3585 2.45926 28.376 7.00735"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.3764 13.0998H33.2095C32.5751 10.6955 30.9914 8.55212 28.7256 7.03105C26.4597 5.50999 23.6504 4.70433 20.7714 4.74994C17.8923 4.79556 15.1198 5.68967 12.9213 7.28147C10.7227 8.87327 9.23281 11.0654 8.70272 13.4881H8.24908C7.24022 13.5511 6.25797 13.7944 5.36562 14.2022C4.92135 14.4051 4.5021 14.6459 4.11421 14.9208C3.90564 15.0681 3.70229 15.2198 3.50415 15.3671C3.08083 15.6977 2.72331 16.0851 2.44566 16.5142C2.20817 16.852 2.01079 17.2094 1.85645 17.5809C0.505972 21.1203 2.44566 23.7804 4.65127 25.0525C6.85689 26.3245 10.6476 26.8378 13.9587 24.3517C16.0345 25.5606 18.4871 26.207 20.9978 26.207C23.5085 26.207 25.9612 25.5606 28.037 24.3517C28.9365 25.0971 30.0359 25.6421 31.2388 25.9389C32.4417 26.2357 33.7113 26.2752 34.9363 26.0541C36.1612 25.8329 37.304 25.3577 38.2644 24.6703C39.2247 23.9829 39.9733 23.1043 40.4444 22.1115C40.9155 21.1186 41.0948 20.042 40.9664 18.9761C40.8381 17.9101 40.4061 16.8874 39.7083 15.9978C39.0105 15.1081 38.0682 14.3786 36.9642 13.8733C35.8603 13.368 34.6283 13.1024 33.3764 13.0998Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_201">
        <rect
          width="60"
          height="40"
          fill="white"
          transform="translate(0.359985)"
        />
      </clipPath>
    </defs>
  </svg>
);

const rainIcon = (
  <svg
    width="61"
    height="40"
    viewBox="0 0 61 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_408)">
      <path
        d="M40.5596 23.3412C40.6613 23.2288 40.8033 23.1521 40.9611 23.1244C43.0399 22.9169 45.0325 22.2589 46.7697 21.2064C50.1277 23.4449 53.0007 23.7512 55.8685 22.2102C58.3609 20.8671 59.8835 18.2045 59.3933 15.6833C58.6738 11.9133 55.9937 10.0283 51.8692 9.75968C50.4927 5.10369 47.3485 2.00756 42.1134 1.1593C35.9867 0.16967 31.5286 2.59663 28.546 7.3987"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.5465 13.8313H33.3796C32.7452 11.2928 31.1615 9.02969 28.8957 7.42368C26.6298 5.81767 23.8205 4.96702 20.9415 5.01518C18.0624 5.06335 15.2899 6.00738 13.0914 7.68808C10.8929 9.36877 9.40291 11.6833 8.87283 14.2413H8.41919C7.41032 14.3079 6.42807 14.5647 5.53573 14.9953C5.09146 15.2096 4.6722 15.4638 4.28432 15.754C4.07575 15.9095 3.87239 16.0697 3.67425 16.2253C3.25094 16.5743 2.89342 16.9834 2.61577 17.4364C2.37828 17.7931 2.18089 18.1704 2.02656 18.5627C0.676077 22.2997 2.61577 25.1084 4.82138 26.4515C7.02699 27.7945 10.8177 28.3365 14.1288 25.7116C16.2046 26.988 18.6573 27.6705 21.168 27.6705C23.6787 27.6705 26.1313 26.988 28.2071 25.7116C29.1066 26.4986 30.206 27.074 31.4089 27.3874C32.6118 27.7008 33.8814 27.7425 35.1064 27.509C36.3313 27.2755 37.4741 26.7738 38.4345 26.048C39.3948 25.3222 40.1434 24.3945 40.6145 23.3462C41.0856 22.298 41.2649 21.1612 41.1365 20.0357C41.0082 18.9103 40.5762 17.8305 39.8784 16.8911C39.1806 15.9517 38.2383 15.1815 37.1344 14.648C36.0304 14.1145 34.7984 13.8341 33.5465 13.8313Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M45.3254 30.509V33.4637"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.8571 30.509V33.4637"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.3888 30.509V33.4637"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.0464 36.1075V39.0575"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.578 36.1075V39.0575"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_408">
        <rect
          width="60"
          height="40"
          fill="white"
          transform="translate(0.530029)"
        />
      </clipPath>
    </defs>
  </svg>
);

const fogIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4 33.8497H8.8C8.58782 33.8497 8.38434 33.7687 8.23431 33.6245C8.08428 33.4803 8 33.2848 8 33.0809C8 32.877 8.08428 32.6814 8.23431 32.5372C8.38434 32.3931 8.58782 32.3121 8.8 32.3121H18.4C18.6122 32.3121 18.8156 32.3931 18.9657 32.5372C19.1157 32.6814 19.2 32.877 19.2 33.0809C19.2 33.2848 19.1157 33.4803 18.9657 33.6245C18.8156 33.7687 18.6122 33.8497 18.4 33.8497ZM31.2 32.3121H26.4C26.1878 32.3121 25.9843 32.3931 25.8343 32.5372C25.6843 32.6814 25.6 32.877 25.6 33.0809C25.6 33.2848 25.6843 33.4803 25.8343 33.6245C25.9843 33.7687 26.1878 33.8497 26.4 33.8497H31.2C31.4122 33.8497 31.6156 33.7687 31.7657 33.6245C31.9157 33.4803 32 33.2848 32 33.0809C32 32.877 31.9157 32.6814 31.7657 32.5372C31.6156 32.3931 31.4122 32.3121 31.2 32.3121ZM26.4 38.4624H15.2C14.9878 38.4624 14.7843 38.5434 14.6343 38.6876C14.4843 38.8318 14.4 39.0273 14.4 39.2312C14.4 39.4351 14.4843 39.6306 14.6343 39.7748C14.7843 39.919 14.9878 40 15.2 40H26.4C26.6122 40 26.8156 39.919 26.9657 39.7748C27.1157 39.6306 27.2 39.4351 27.2 39.2312C27.2 39.0273 27.1157 38.8318 26.9657 38.6876C26.8156 38.5434 26.6122 38.4624 26.4 38.4624ZM40 13.861C39.9947 17.5296 38.4759 21.0465 35.7765 23.6406C33.0771 26.2346 29.4175 27.6942 25.6 27.6993H9.6C7.05392 27.6993 4.61212 26.7273 2.81177 24.9972C1.01143 23.2671 0 20.9206 0 18.4738C0 16.027 1.01143 13.6805 2.81177 11.9504C4.61212 10.2203 7.05392 9.24828 9.6 9.24828C10.3816 9.25124 11.1601 9.34154 11.92 9.51736C12.9899 6.38915 15.1855 3.73009 18.1124 2.0179C21.0393 0.305702 24.5055 -0.347408 27.8885 0.175902C31.2715 0.699211 34.3494 2.36464 36.5693 4.87299C38.7892 7.38133 40.0056 10.5682 40 13.861V13.861ZM38.4 13.861C38.4 10.5987 37.0514 7.46997 34.651 5.16314C32.2505 2.85632 28.9948 1.56035 25.6 1.56035C22.2052 1.56035 18.9495 2.85632 16.549 5.16314C14.1486 7.46997 12.8 10.5987 12.8 13.861C12.8 14.0649 12.7157 14.2605 12.5657 14.4047C12.4157 14.5488 12.2122 14.6298 12 14.6298C11.7878 14.6298 11.5843 14.5488 11.4343 14.4047C11.2843 14.2605 11.2 14.0649 11.2 13.861C11.1977 12.8991 11.2982 11.9395 11.5 10.9973C10.8767 10.8596 10.2395 10.7887 9.6 10.7859C7.47826 10.7859 5.44343 11.5958 3.94314 13.0376C2.44285 14.4794 1.6 16.4348 1.6 18.4738C1.6 20.5128 2.44285 22.4682 3.94314 23.91C5.44343 25.3517 7.47826 26.1617 9.6 26.1617H25.6C28.9931 26.1566 32.2458 24.859 34.6451 22.5533C37.0444 20.2476 38.3947 17.1218 38.4 13.861V13.861Z"
      fill="white"
    />
  </svg>
);

const windIcon = (
  <svg
    width="61"
    height="40"
    viewBox="0 0 61 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_379)">
      <path
        d="M40.083 32.6392C40.184 32.482 40.325 32.3748 40.4817 32.3361C42.5461 32.0459 44.525 31.1258 46.2502 29.654C49.585 32.7842 52.4382 33.2125 55.2862 31.0576C57.7614 29.1796 59.2734 25.4563 58.7867 21.9308C58.0721 16.659 55.4105 14.023 51.3145 13.6474C49.9475 7.13671 46.825 2.80723 41.6261 1.62106C35.5417 0.23721 31.1143 3.63095 28.1523 10.3459"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.1183 19.341H32.9526C32.3225 15.7913 30.7497 12.6267 28.4995 10.3809C26.2494 8.13512 23.4594 6.94561 20.6003 7.01296C17.7411 7.08032 14.9877 8.40041 12.8044 10.7506C10.621 13.1008 9.14138 16.3373 8.61496 19.9143H8.16445C7.16255 20.0074 6.18708 20.3666 5.3009 20.9687C4.8597 21.2683 4.44334 21.6238 4.05812 22.0296C3.851 22.2471 3.64905 22.4711 3.45227 22.6886C3.03188 23.1767 2.67683 23.7487 2.4011 24.3822C2.16525 24.881 1.96923 25.4086 1.81596 25.9571C0.474799 31.1828 2.4011 35.1103 4.59148 36.9884C6.78187 38.8665 10.5464 39.6244 13.8346 35.9538C15.8961 37.7387 18.3318 38.6931 20.8252 38.6931C23.3186 38.6931 25.7543 37.7387 27.8158 35.9538C28.709 37.0543 29.8008 37.859 30.9954 38.2972C32.19 38.7354 33.4509 38.7938 34.6674 38.4672C35.8838 38.1407 37.0187 37.4392 37.9725 36.4243C38.9262 35.4094 39.6696 34.1121 40.1375 32.6462C40.6054 31.1804 40.7834 29.5908 40.6559 28.017C40.5284 26.4432 40.0994 24.9333 39.4064 23.6197C38.7134 22.3061 37.7777 21.2291 36.6814 20.4831C35.585 19.7371 34.3615 19.3449 33.1183 19.341Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M53.8622 3.20264L40.927 14.6096"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M41.4501 8.883L40.6941 14.7611L45.137 15.3542"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M59.5531 10.7281L46.6179 22.1351"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.1408 16.4086L46.3796 22.2867L50.8226 22.8797"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_379">
        <rect
          width="60"
          height="40"
          fill="white"
          transform="translate(0.329834)"
        />
      </clipPath>
    </defs>
  </svg>
);

const cloudyIcon = (
  <svg
    width="60"
    height="27"
    viewBox="0 0 60 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.9196 21.6572C40.0213 21.5529 40.1633 21.4817 40.3211 21.456C42.3998 21.2635 44.3925 20.653 46.1297 19.6764C49.4877 21.7534 52.3607 22.0376 55.2285 20.6078C57.7209 19.3616 59.2435 16.8911 58.7533 14.5518C58.0338 11.0538 55.3536 9.30474 51.2292 9.05551C49.8526 4.73544 46.7085 1.86268 41.4734 1.07562C35.3467 0.15739 30.8885 2.40925 27.906 6.86487"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M32.9065 12.8334H32.7396C32.1052 10.478 30.5215 8.37822 28.2556 6.88808C25.9898 5.39794 23.1805 4.60866 20.3015 4.65335C17.4224 4.69804 14.6499 5.57397 12.4514 7.1334C10.2528 8.69284 8.7629 10.8404 8.23281 13.2138H7.77918C6.77031 13.2756 5.78806 13.5139 4.89571 13.9134C4.45144 14.1122 4.03219 14.3481 3.6443 14.6174C3.43573 14.7617 3.23238 14.9104 3.03424 15.0547C2.61092 15.3785 2.2534 15.7581 1.97575 16.1784C1.73827 16.5094 1.54088 16.8595 1.38654 17.2234C0.0360625 20.6909 1.97575 23.2969 4.18136 24.5431C6.38698 25.7892 10.1777 26.2921 13.4887 23.8566C15.5646 25.0409 18.0172 25.6742 20.5279 25.6742C23.0386 25.6742 25.4913 25.0409 27.5671 23.8566C28.4666 24.5868 29.566 25.1207 30.7689 25.4114C31.9718 25.7022 33.2414 25.741 34.4664 25.5243C35.6913 25.3076 36.8341 24.8421 37.7944 24.1687C38.7548 23.4953 39.5034 22.6345 39.9745 21.6619C40.4456 20.6892 40.6249 19.6345 40.4965 18.5902C40.3682 17.546 39.9361 16.5441 39.2383 15.6725C38.5405 14.8009 37.5983 14.0862 36.4943 13.5912C35.3904 13.0962 34.1584 12.836 32.9065 12.8334Z"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </svg>
);

const partlyCloudyDayIcon = (
  <svg
    width="61"
    height="40"
    viewBox="0 0 61 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_396)">
      <path
        d="M20.0681 8.72972C19.4512 6.93492 18.5178 5.35199 17.3428 4.10776C16.1678 2.86353 14.7838 1.9926 13.3016 1.56477C11.8195 1.13693 10.2805 1.16409 8.808 1.64406C7.33546 2.12403 5.97032 3.04347 4.82196 4.3287C3.67361 5.61393 2.77398 7.22921 2.19516 9.04511C1.61634 10.861 1.37442 12.827 1.4888 14.7856C1.60318 16.7442 2.07067 18.6409 2.85381 20.3238C3.63695 22.0066 4.71396 23.4288 5.99854 24.4763"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M41.6254 32.894C41.7212 32.7387 41.8579 32.6344 42.0093 32.6011C43.9716 32.3101 45.8509 31.4125 47.4885 29.9841C50.6588 33.0086 53.396 33.4289 56.0789 31.3404C58.4321 29.5257 59.8745 25.9345 59.4117 22.5279C58.7274 17.434 56.1971 14.887 52.308 14.5177C51.0084 8.27766 48.0349 4.06244 43.0924 2.92268C37.3129 1.58552 33.1039 4.86473 30.2929 11.3467"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M35.0091 20.0382H34.8318C34.2328 16.6083 32.7376 13.5505 30.5984 11.3805C28.4592 9.21051 25.8068 8.06114 23.0886 8.12622C20.3705 8.19129 17.7528 9.46684 15.6772 11.7377C13.6015 14.0086 12.1948 17.1359 11.6943 20.5922C11.5516 20.5922 11.4088 20.5922 11.266 20.5922C10.3107 20.7 9.38255 21.0597 8.53876 21.6492C8.12616 21.9312 7.73546 22.2638 7.37204 22.6425C7.17121 22.841 6.97893 23.0535 6.79607 23.2792C6.39383 23.7356 6.05136 24.2731 5.78195 24.8711C5.55712 25.3549 5.37074 25.8669 5.22567 26.3992C3.96049 31.4932 5.79672 35.2499 7.87418 37.0646C10.0304 38.9748 13.5355 39.6116 16.6664 36.0713C18.6263 37.7959 20.9419 38.7182 23.3123 38.7182C25.6827 38.7182 27.9983 37.7959 29.9582 36.0713C30.8058 37.1389 31.8431 37.9208 32.9791 38.3482C34.1151 38.7757 35.3148 38.8357 36.4729 38.5229C37.631 38.2101 38.7119 37.5341 39.6207 36.5543C40.5294 35.5745 41.2381 34.321 41.6846 32.9039C42.131 31.4868 42.3014 29.9496 42.1809 28.4274C42.0603 26.9051 41.6525 25.4445 40.9932 24.1739C40.334 22.9033 39.4435 21.8616 38.4 21.1405C37.3566 20.4194 36.1921 20.0408 35.0091 20.0382V20.0382Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_396">
        <rect
          width="60"
          height="40"
          fill="white"
          transform="translate(0.47998)"
        />
      </clipPath>
    </defs>
  </svg>
);

const partlyCloudyNightIcon = (
  <svg
    width="61"
    height="40"
    viewBox="0 0 61 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2_402)">
      <path
        d="M9.9403 19.2092C9.11588 17.001 8.82245 14.5406 9.09574 12.1274C9.53723 9.14347 10.6692 6.38721 12.3512 4.20044C12.8065 3.57893 13.292 2.99301 13.8048 2.446C13.1449 2.02158 12.4425 1.70933 11.7164 1.51756C9.96691 1.0467 8.14315 1.28017 6.50612 2.18457C4.86908 3.08896 3.50268 4.61792 2.60242 6.55268C1.70215 8.48744 1.31417 10.7288 1.49398 12.9562C1.67379 15.1835 2.41218 17.2826 3.6035 18.9531C4.38827 20.0467 5.34953 20.9197 6.42384 21.5144"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M40.8309 32.8542C40.9291 32.6978 41.069 32.5909 41.2251 32.5532C43.2657 32.2665 45.2204 31.3657 46.922 29.928C50.2184 32.9694 53.0643 33.392 55.854 31.2918C58.3007 29.4541 59.8055 25.8556 59.3193 22.4108C58.6078 17.2883 55.9768 14.7271 51.9331 14.3557C50.5921 8.07429 47.4902 3.84186 42.3512 2.71492C36.3419 1.37027 31.9656 4.66785 29.0428 11.1862"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M33.9464 19.9264H33.7622C33.1393 16.4772 31.5847 13.4023 29.3604 11.2201C27.1361 9.03801 24.3784 7.8822 21.5521 7.94764C18.7259 8.01308 16.0042 9.29578 13.846 11.5794C11.6878 13.863 10.2252 17.0078 9.70484 20.4834H9.25952C8.27136 20.5779 7.30945 20.9267 6.43407 21.5079C6.00602 21.7927 5.60141 22.1294 5.22608 22.5132C5.01726 22.7128 4.81734 22.9266 4.62721 23.1535C4.20779 23.611 3.85154 24.1518 3.57278 24.7543C3.33506 25.257 3.13952 25.7892 2.98926 26.3422C1.67379 31.4647 3.58302 35.2489 5.74306 37.0738C7.985 38.9947 11.6294 39.635 14.8848 36.0749C16.9252 37.8045 19.3342 38.7263 21.7989 38.7206C24.2635 38.7149 26.6698 37.7819 28.705 36.0429C29.5861 37.1184 30.6651 37.9063 31.847 38.3374C33.0288 38.7685 34.2772 38.8295 35.4824 38.515C36.6875 38.2006 37.8123 37.5203 38.7578 36.534C39.7033 35.5478 40.4404 34.2859 40.9043 32.8595C41.3683 31.433 41.5447 29.8857 41.4181 28.3539C41.2916 26.8221 40.8659 25.3527 40.1785 24.0751C39.4912 22.7975 38.5633 21.7509 37.4765 21.0274C36.3898 20.304 35.1775 19.9259 33.9464 19.9264V19.9264Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_2_402">
        <rect
          width="60"
          height="40"
          fill="white"
          transform="translate(0.429932)"
        />
      </clipPath>
    </defs>
  </svg>
);

const clearDayIcon = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 6.30997C18.2652 6.30997 18.5196 6.20462 18.7071 6.01708C18.8946 5.82954 19 5.57519 19 5.30997V1.90997C19 1.64476 18.8946 1.3904 18.7071 1.20287C18.5196 1.01533 18.2652 0.909973 18 0.909973C17.7348 0.909973 17.4804 1.01533 17.2929 1.20287C17.1054 1.3904 17 1.64476 17 1.90997V5.30997C17 5.57519 17.1054 5.82954 17.2929 6.01708C17.4804 6.20462 17.7348 6.30997 18 6.30997Z"
      fill="white"
    />
    <path
      d="M18 29.69C17.7348 29.69 17.4804 29.7954 17.2929 29.9829C17.1054 30.1704 17 30.4248 17 30.69V34.09C17 34.3552 17.1054 34.6096 17.2929 34.7971C17.4804 34.9846 17.7348 35.09 18 35.09C18.2652 35.09 18.5196 34.9846 18.7071 34.7971C18.8946 34.6096 19 34.3552 19 34.09V30.69C19 30.4248 18.8946 30.1704 18.7071 29.9829C18.5196 29.7954 18.2652 29.69 18 29.69V29.69Z"
      fill="white"
    />
    <path
      d="M8.32002 9.74002C8.50597 9.90905 8.74874 10.0019 9.00002 10C9.13163 10.0008 9.26209 9.97556 9.38393 9.92579C9.50577 9.87603 9.61658 9.8027 9.71002 9.71002C9.80375 9.61706 9.87814 9.50646 9.92891 9.3846C9.97968 9.26274 10.0058 9.13203 10.0058 9.00002C10.0058 8.86801 9.97968 8.7373 9.92891 8.61545C9.87814 8.49359 9.80375 8.38299 9.71002 8.29002L7.33002 5.92002C7.13872 5.7562 6.89265 5.67059 6.64097 5.68031C6.38929 5.69003 6.15055 5.79436 5.97246 5.97246C5.79436 6.15055 5.69003 6.38929 5.68031 6.64097C5.67059 6.89265 5.7562 7.13872 5.92002 7.33002L8.32002 9.74002Z"
      fill="white"
    />
    <path
      d="M27.68 26.26C27.5867 26.1667 27.476 26.0928 27.3542 26.0423C27.2324 25.9919 27.1018 25.9659 26.97 25.9659C26.8381 25.9659 26.7075 25.9919 26.5857 26.0423C26.4639 26.0928 26.3532 26.1667 26.26 26.26C26.1667 26.3532 26.0928 26.4639 26.0423 26.5857C25.9919 26.7075 25.9659 26.8381 25.9659 26.97C25.9659 27.1018 25.9919 27.2324 26.0423 27.3542C26.0928 27.476 26.1667 27.5867 26.26 27.68L28.67 30.08C28.7626 30.1745 28.873 30.2496 28.9949 30.3011C29.1168 30.3526 29.2477 30.3794 29.38 30.38C29.6437 30.3762 29.8953 30.2684 30.08 30.08C30.2662 29.8926 30.3708 29.6392 30.3708 29.375C30.3708 29.1108 30.2662 28.8573 30.08 28.67L27.68 26.26Z"
      fill="white"
    />
    <path
      d="M6.30997 18C6.30997 17.7348 6.20462 17.4804 6.01708 17.2929C5.82954 17.1054 5.57519 17 5.30997 17H1.90997C1.64476 17 1.3904 17.1054 1.20287 17.2929C1.01533 17.4804 0.909973 17.7348 0.909973 18C0.909973 18.2652 1.01533 18.5196 1.20287 18.7071C1.3904 18.8946 1.64476 19 1.90997 19H5.30997C5.57519 19 5.82954 18.8946 6.01708 18.7071C6.20462 18.5196 6.30997 18.2652 6.30997 18Z"
      fill="white"
    />
    <path
      d="M34.09 17H30.69C30.4248 17 30.1704 17.1054 29.9829 17.2929C29.7954 17.4804 29.69 17.7348 29.69 18C29.69 18.2652 29.7954 18.5196 29.9829 18.7071C30.1704 18.8946 30.4248 19 30.69 19H34.09C34.3552 19 34.6096 18.8946 34.7971 18.7071C34.9846 18.5196 35.09 18.2652 35.09 18C35.09 17.7348 34.9846 17.4804 34.7971 17.2929C34.6096 17.1054 34.3552 17 34.09 17Z"
      fill="white"
    />
    <path
      d="M8.32001 26.26L5.92001 28.67C5.77959 28.8092 5.68362 28.987 5.64424 29.1808C5.60485 29.3747 5.62382 29.5758 5.69875 29.7588C5.77367 29.9419 5.90119 30.0986 6.06517 30.2091C6.22916 30.3197 6.42224 30.3791 6.62001 30.38C6.75232 30.3794 6.8832 30.3526 7.00508 30.3011C7.12695 30.2496 7.2374 30.1745 7.33001 30.08L9.74001 27.68C9.92832 27.4917 10.0341 27.2363 10.0341 26.97C10.0341 26.7037 9.92832 26.4483 9.74001 26.26C9.55171 26.0717 9.29632 25.9659 9.03001 25.9659C8.76371 25.9659 8.50832 26.0717 8.32001 26.26V26.26Z"
      fill="white"
    />
    <path
      d="M27 9.99997C27.1316 10.0007 27.2621 9.97551 27.3839 9.92575C27.5057 9.87598 27.6166 9.80266 27.71 9.70997L30.11 7.29997C30.2963 7.11261 30.4008 6.85916 30.4008 6.59497C30.4008 6.33079 30.2963 6.07734 30.11 5.88997C29.9226 5.70372 29.6692 5.59918 29.405 5.59918C29.1408 5.59918 28.8874 5.70372 28.7 5.88997L26.29 8.28997C26.1963 8.38294 26.1219 8.49354 26.0711 8.6154C26.0203 8.73726 25.9942 8.86796 25.9942 8.99997C25.9942 9.13199 26.0203 9.26269 26.0711 9.38455C26.1219 9.50641 26.1963 9.61701 26.29 9.70997C26.3834 9.80266 26.4943 9.87598 26.6161 9.92575C26.7379 9.97551 26.8684 10.0007 27 9.99997Z"
      fill="white"
    />
    <path
      d="M18.13 7.74998C16.1211 7.7242 14.15 8.29633 12.4671 9.39364C10.7842 10.4909 9.46562 12.0639 8.67893 13.9125C7.89224 15.7611 7.67299 17.8018 8.04906 19.7753C8.42512 21.7489 9.37951 23.566 10.7909 24.9957C12.2023 26.4255 14.0069 27.4033 15.9754 27.8048C17.9439 28.2063 19.9874 28.0134 21.846 27.2507C23.7046 26.4879 25.2944 25.1898 26.4133 23.5212C27.5323 21.8526 28.1298 19.889 28.13 17.88C28.1433 15.2118 27.0982 12.6471 25.2236 10.7482C23.3491 8.84931 20.7982 7.77112 18.13 7.74998V7.74998ZM18.13 26C16.5163 26.0258 14.9315 25.5707 13.5773 24.6928C12.2231 23.8148 11.1609 22.5537 10.5258 21.07C9.8908 19.5863 9.71172 17.9472 10.0114 16.3614C10.3111 14.7756 11.0759 13.3148 12.2086 12.1652C13.3413 11.0155 14.7904 10.229 16.3716 9.90577C17.9528 9.58252 19.5944 9.73718 21.0874 10.3501C22.5804 10.9629 23.8572 12.0063 24.7552 13.3472C25.6532 14.6882 26.1318 16.2661 26.13 17.88C26.1407 20.0161 25.3051 22.0695 23.8059 23.5911C22.3067 25.1128 20.266 25.9789 18.13 26V26Z"
      fill="white"
    />
  </svg>
);

const clearNightIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.4531 23.6719C34.4131 23.5413 34.3324 23.4269 34.2228 23.3453C34.1132 23.2638 33.9804 23.2195 33.8437 23.2188L33.6562 23.2501C31.3122 23.8962 28.8388 23.9092 26.4881 23.2878C24.1374 22.6664 21.9935 21.4328 20.275 19.7127C18.5565 17.9926 17.3248 15.8476 16.7056 13.4963C16.0864 11.145 16.1017 8.6716 16.75 6.32818C16.7628 6.28246 16.7681 6.23496 16.7656 6.18755C16.7751 6.05542 16.7424 5.92368 16.6722 5.81134C16.602 5.69901 16.4979 5.61188 16.375 5.56255C16.2454 5.51099 16.102 5.50548 15.9687 5.54693C13.4461 6.25208 11.1521 7.60553 9.31494 9.47259C7.4778 11.3397 6.16161 13.6553 5.49731 16.189C4.83301 18.7227 4.84377 21.3862 5.52852 23.9144C6.21327 26.4427 7.54813 28.7476 9.40029 30.5997C11.2525 32.4519 13.5573 33.7868 16.0856 34.4715C18.6139 35.1563 21.2774 35.167 23.8111 34.5027C26.3448 33.8384 28.6604 32.5222 30.5275 30.6851C32.3945 28.848 33.748 26.5539 34.4531 24.0313C34.4842 23.9135 34.4842 23.7897 34.4531 23.6719ZM20 33.7501C16.7654 33.7545 13.6328 32.6185 11.1529 30.5418C8.67308 28.4651 7.00473 25.5806 6.44122 22.3955C5.87772 19.2104 6.45513 15.9286 8.07195 13.1271C9.68877 10.3256 12.2415 8.18374 15.2812 7.07818C14.8034 9.49736 14.9287 11.997 15.6462 14.3562C16.3636 16.7155 17.651 18.8618 19.3946 20.6054C21.1383 22.3491 23.2846 23.6365 25.6438 24.3539C28.0031 25.0713 30.5027 25.1966 32.9219 24.7188C31.9483 27.3638 30.1881 29.6472 27.8779 31.2618C25.5677 32.8764 22.8185 33.7448 20 33.7501V33.7501Z"
      fill="white"
    />
  </svg>
);

type TIcons = {
  [key: string]: JSX.Element;
};

export const wheatherIcons: TIcons = {
  snow: snowIcon,
  rain: rainIcon,
  fog: fogIcon,
  wind: windIcon,
  cloudy: cloudyIcon,
  partlyCloudyDay: partlyCloudyDayIcon,
  partlyCloudyNight: partlyCloudyNightIcon,
  clearDay: clearDayIcon,
  clearNight: clearNightIcon,
};
